import React, { useContext, useState } from "react";
import "../Styles/Login.css";
import { useMutation } from "@apollo/client";
import { LOGIN_USER } from "../GraphQL/Mutations";
import { AuthContext } from "../../context/auth";
import { useMyForm } from "../../util/hooks";
import { withRouter } from "react-router";
import { useHistory } from "react-router-dom";
import { Form, Input, Button, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";

function Login(props) {
  let history = useHistory();

  const context = useContext(AuthContext);
  const [errors, setErrors] = useState({});

  const { onChange, onSubmit, values } = useMyForm(loginUserCallback, {
    username: "",
    password: "",
  });

  const [loginUser, { loading }] = useMutation(LOGIN_USER, {
    update(_, { data: { login: userData } }) {
      context.login(userData);
      localStorage.setItem("username", userData.username);
      message.success("You have successfully logged in");
      history.push("/");
      // window.location.reload();
    },
    onError(err) {
      const messageError = err.graphQLErrors[0].message;
      message.error(messageError);
      setErrors(err.graphQLErrors[0].extensions.errors);
    },
    variables: values,
  });

  function loginUserCallback() {
    loginUser();
  }

  return (
    <>
      <div className="form-container">
        <h1>Login</h1>
        <Form onFinish={onSubmit} className={loading ? "loading" : ""}>
          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: "Please input your username!",
              },
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              onChange={onChange}
              value={values.username}
              name="username"
              type="text"
              placeholder="Username"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              onChange={onChange}
              value={values.password}
              name="password"
              type="password"
              placeholder="Password"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              Log in
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
}


export default withRouter(Login);



